// Help center articles linked from the app. Each one carries the id in the
// legacy Intercom help center and, once the article has been copied there, the
// id in the unified Zendesk help center. A missing Zendesk id falls back to the
// Intercom link, so the two cutovers are independent.
export type HelpCenterArticle = {
  intercom: number;
  zendesk: number | null;
};

export const HOW_ONA_REDUCE_BIAS: HelpCenterArticle = {
  intercom: 9664282,
  zendesk: 40303332291997,
};
export const PERFORMANCE_CONVERSATIONS_MANAGERS_GUIDE: HelpCenterArticle = {
  intercom: 10929035,
  zendesk: 40302923299101,
};
export const PERFORMANCE_CONVERSATIONS_EMPLOYEE_GUIDE: HelpCenterArticle = {
  intercom: 10929752,
  zendesk: 40302951855133,
};
export const ONE_ON_ONES: HelpCenterArticle = {
  intercom: 6925983,
  zendesk: 40303239341213,
};
export const OKRS: HelpCenterArticle = {
  intercom: 6005129,
  zendesk: 40303219561629,
};
export const ROCK_STARS_VS_SUPERSTARS: HelpCenterArticle = {
  intercom: 5743023,
  zendesk: 40303190378013,
};
export const FLOW_STATE: HelpCenterArticle = {
  intercom: 5743041,
  zendesk: 40303183258141,
};
export const PERFORMANCE_IMPROVEMENT_PLANS: HelpCenterArticle = {
  intercom: 5743054,
  zendesk: 40303194873117,
};
export const REFERRALS_SHARE_REFER_EARN: HelpCenterArticle = {
  intercom: 8511562,
  zendesk: 40303311159965,
};
export const IMPORT_CSV_SPECIAL_CHARACTERS: HelpCenterArticle = {
  intercom: 9617090,
  zendesk: 40303316251165,
};
